var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXdaicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3282 19.5729V16.5405H35.1209V34.0107H27.3282V31.0061H31.8897V19.5729H27.3282ZM19.1103 30.9773V19.5451H23.6728V16.5405H15.8802V34.0107H20.5122L23.6718 40.3865V30.9643L19.1103 30.9773Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.8459,
    height: 23.8459,
    fill: "white",
    transform: "translate(13.577 16.5405)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdaicon);
export default __webpack_public_path__ + "static/media/xdaicon.2310e0bc0a1a3fa610562acce95bd9d0.svg";
export { ForwardRef as ReactComponent };